export function filterObj<T extends Record<string, unknown>>(
  obj: T,
  filterCondition: (value: T[keyof T]) => boolean
) {
  const result: Partial<T> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      if (!filterCondition(value)) continue;
      result[key] = value;
    }
  }

  return result;
}

export function filterObjectByList<T extends Record<string, unknown>>(
  obj: T,
  list: string[]
) {
  const result: Partial<T> = {};

  for (const item of list) {
    if (item in obj) {
      result[item as keyof T] = obj[item as keyof T];
    }
  }
  return result;
}

export function uniqueArray<T>(array: T[]): T[] {
  return Array.from(new Set(array));
}
